import { render, staticRenderFns } from "./PresupuestoTable.vue?vue&type=template&id=326d6ba5&scoped=true&"
import script from "./PresupuestoTable.vue?vue&type=script&lang=js&"
export * from "./PresupuestoTable.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestoTable.vue?vue&type=style&index=0&id=326d6ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d6ba5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VSnackbar,
  VSubheader,
  VTextField,
  VTooltip,
})
